import axios from 'axios';
import qs from 'qs';
import helpers from '../util/helpers';
import * as constants from '../util/constants';

export default {
  init() {},
  finalize() {
    // JavaScript to be fired on the home page, after the init JS

    // Global gift shop hotels
    const giftShopHotelsWrapper = $('#global-gift-shop-hotels-wrapper');
    if (giftShopHotelsWrapper.length) {
      // Cancel token source
      let cancelTokenSource = null;

      const handleGiftShopHotelsResults = function() {
        // Cancel previous request if it exists
        if (cancelTokenSource) {
          cancelTokenSource.cancel('New request initiated, cancel previous.');
        }
        cancelTokenSource = axios.CancelToken.source();

        const skeleton = $('#global-gift-shop-hotels-skeleton');
        const params = helpers.getParameters();

        giftShopHotelsWrapper.html('');
        skeleton.show();

        // Params
        const data = {
          'action': constants.ACTION_GET_GLOBAL_GIFT_SHOP_HOTELS,
          'location': params['location'] || '',
        };

        // Send request
        axios.post(window.Rydges['ajaxUrl'], qs.stringify(data), {
          cancelToken: cancelTokenSource.token,
        }).then((axiosResponse) => {
          if (200 === axiosResponse.status) {
            const response = axiosResponse.data;

            skeleton.hide();

            if (response.success) {
              const html = response.data['html'];

              if (html.length) {
                giftShopHotelsWrapper.html(html);
              }

              // Equal height for elements
              $(document).trigger(constants.EVENT_BALANCE_ELEMENTS);
            }
          }
        }).catch((error) => {
          console.log(error);
        });
      };

      const giftShopHotelsFilter = $('#gift-shop-hotel-locations-filter');
      if (giftShopHotelsFilter.length) {
        giftShopHotelsFilter.on('select2:select', function() {
          const selectedVal = giftShopHotelsFilter.val();
          const params = helpers.getParameters();

          if (selectedVal !== '') {
            params['location'] = selectedVal;
          } else {
            delete params['location'];
          }

          // Push params to url
          helpers.pushStateHistory(!$.isEmptyObject(params) ? '?' + $.param(params) : '');

          handleGiftShopHotelsResults();

          $(document).trigger(constants.EVENT_SELECT_FILTER_CHANGED, [selectedVal]);
        });
      }
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateGlobalGiftCards.js